import type { SpecSectionField } from 'Components/SpecSection/SpecSection.types';
import type { WheelAndTyres } from 'Pages/vehicles/helpers/vehicle.schema';

import { DamageWithImage } from '../ConditionAndDamageSection/Components/DamageWithImage/DamageWithImage';

export const wheelsAndTyresFields: SpecSectionField<WheelAndTyres>[] = [
	{
		fieldName: 'hasTyreProblems',
		isVisible: () => true,
		label: () => 'Tyre problems',
		value: ({ hasTyreProblems, tyreProblemsDesc }) => (
			<DamageWithImage damageDescription={tyreProblemsDesc} hasDamage={hasTyreProblems} kind="damage_tyres" />
		),
	},
	{
		fieldName: 'hasScuffedAlloy',
		isVisible: () => true,
		label: () => 'Scuffed alloys',
		value: ({ hasScuffedAlloy, scuffedAlloyDesc }) => (
			<DamageWithImage damageDescription={scuffedAlloyDesc} hasDamage={hasScuffedAlloy} kind="damage_alloy_scuffs" />
		),
	},
	{
		fieldName: 'hasToolsInBoot',
		isVisible: () => true,
		label: () => 'Tool pack',
		value: ({ hasToolsInBoot }) => hasToolsInBoot,
	},
	{
		fieldName: 'hasLockingWheelNut',
		isVisible: () => true,
		label: () => 'Locking wheel nut',
		value: ({ hasLockingWheelNut }) => hasLockingWheelNut,
	},
];

export const WHEEL_IMAGE_KIND = [
	'wheels_front_driver',
	'wheels_front_passenger',
	'wheels_rear_driver',
	'wheels_rear_passenger',
];

export const TYRE_IMAGE_KIND = [
	'tyre_tread_front_driver',
	'tyre_tread_rear_driver',
	'tyre_tread_front_passenger',
	'tyre_tread_rear_passenger',
];

export const mobilizeWheelsAndTyresFields = wheelsAndTyresFields.filter(
	(field) => field.fieldName !== 'hasScuffedAlloy',
);
